import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Actions, ofType } from '@ngrx/effects';
import {
  EDisplayProFleetModalActions,
  GetProFleetList
} from '../../store/actions/display-pro-fleet-modal.actions';
import { ProFleetInterface } from '../../models/pro-fleet.interface';
import { ProFleetService } from '../../services/pro-fleet.service';
import { GetCustomer } from '../../../account/store/actions/customer.actions';
import { TokenLocalStorageService } from '../../../authentication/services/token-local-storage.service';
import { Store } from '@ngrx/store';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { CustomerStorageService } from '../../../account/services/customer-storage.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';

@Component({
  selector: 'app-pro-fleet-modal',
  templateUrl: './pro-fleet-modal.component.html',
  styleUrls: ['./pro-fleet-modal.component.css'],
  standalone: false
})
export class ProFleetModalComponent implements OnInit {

  environment = environment;
  visibility: boolean;
  selectedCustomerId: string|null;
  connectedCustomer: CustomerInterface|null;
  data: Array<ProFleetInterface> = [];

  constructor(
      private actions$: Actions,
      private store: Store<any>,
      private proFleetService: ProFleetService,
      private localStorageService: TokenLocalStorageService,
      private customerStorageService: CustomerStorageService,
  ) {}

  ngOnInit() {
    this.visibility = false;
    this.selectedCustomerId = null;
    this.connectedCustomer = null;
    this.actions$.pipe(ofType(EDisplayProFleetModalActions.GetProFleetList)).subscribe(( response: GetProFleetList) => {
      this.visibility = response.visibility;
      this.data = [];
      this.selectedCustomerId = null;
      this.connectedCustomer = this.customerStorageService.getCustomer();
      this.proFleetService.getList().subscribe(list => { this.data = list; });
    });
  }

  close() {
    this.visibility = false;
    this.selectedCustomerId = null;
  }

  setSelectedCustomer(customerId: string) {
    this.selectedCustomerId = customerId;
  }

  getToken() {
    this.proFleetService.getToken(this.selectedCustomerId).subscribe(
        response => {
          this.close();
          localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER);
          this.localStorageService.save(response, false);
          this.store.dispatch(new GetCustomer());
          window.location.reload();
        }
    );
  }
}
